import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, IconButton, Select, MenuItem, Typography } from '@mui/material';
import { compactControl } from '../../components/page-primitives';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
// Distance from the content column's right edge to the viewport edge: the centered
// PageContainer's outer gap (its cap is the xl breakpoint) plus its 1.5rem gutter (sm and up).
const edgeBleed = (theme) => `calc((100vw - min(100vw, ${theme.breakpoints.values.xl}px)) / 2 + 1.5rem)`;
export const SearchHeader = props => {
    const { sortBy, sortOrder, onSortByChanged, onSortOrderChanged } = props;
    const handleSortByChange = (event) => {
        onSortByChanged(event.target.value);
    };
    const toggleSortOrder = () => {
        onSortOrderChanged(sortOrder === 'asc' ? 'desc' : 'asc');
    };
    const title = props.searchQuery ? `"${props.searchQuery}"` : props.category || 'All extensions';
    return (_jsxs(Box
    // Bleeds left to meet the sidebar seam and right to the viewport edge;
    // matching padding keeps the content itself on the column grid.
    , { 
        // Bleeds left to meet the sidebar seam and right to the viewport edge;
        // matching padding keeps the content itself on the column grid.
        sx: theme => ({
            pt: '1.75rem',
            pb: '0.875rem',
            mb: '1rem',
            ml: { md: '-1.25rem' },
            pl: { md: '1.25rem' },
            mr: { xs: '-1rem', sm: `calc(${edgeBleed(theme)} * -1)` },
            pr: { xs: '1rem', sm: edgeBleed(theme) },
            borderBottom: '1px solid',
            borderColor: 'border2',
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            gap: '1rem'
        }), children: [_jsxs(Box, { sx: { flex: 1, minWidth: 0 }, children: [_jsx(Typography, { component: 'h1', noWrap: true, sx: {
                            fontSize: { xs: '1.25rem', sm: '1.6rem' },
                            fontWeight: 700,
                            letterSpacing: '-0.025em',
                            lineHeight: 1.2,
                            color: 'text.primary'
                        }, children: title }), _jsxs(Typography, { sx: { fontSize: '0.8125rem', color: 'text.disabled', mt: '0.3125rem' }, children: [props.resultNumber.toLocaleString(), " extensions found"] })] }), _jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: '0.375rem', flexShrink: 0, mt: '0.375rem' }, children: [_jsx(Box, { component: 'span', sx: { fontSize: '0.8125rem', color: 'text.disabled' }, children: "Sort by" }), _jsxs(Select, { value: sortBy, onChange: handleSortByChange, size: 'small', inputProps: { 'aria-label': 'Sort by' }, sx: compactControl, children: [_jsx(MenuItem, { value: 'relevance', children: "Relevance" }), _jsx(MenuItem, { value: 'timestamp', children: "Date" }), _jsx(MenuItem, { value: 'downloadCount', children: "Downloads" }), _jsx(MenuItem, { value: 'rating', children: "Rating" })] }), _jsx(IconButton, { onClick: toggleSortOrder, title: sortOrder === 'asc' ? 'Ascending' : 'Descending', "aria-label": sortOrder === 'asc' ? 'Sort ascending' : 'Sort descending', sx: {
                            color: 'text.disabled',
                            borderRadius: 1,
                            p: '0.1875rem',
                            transition: 'color 0.14s',
                            '&:hover': { color: 'secondary.light', bgcolor: 'transparent' }
                        }, children: sortOrder === 'asc' ? (_jsx(ArrowUpwardIcon, { fontSize: 'small' })) : (_jsx(ArrowDownwardIcon, { fontSize: 'small' })) })] })] }));
};
//# sourceMappingURL=search-header.js.map